import { _creditForCaseToCase } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

interface Payload {
  modality: string;
  credit: number;
}
export const addCaseCredit = createAsyncThunk(
  'creditForCaseToCase/add',
  async (payload: Payload, thunkAPI) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(_creditForCaseToCase.post, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok) {
        const errorMessage = data?.message || 'Failed to add credit';
        return thunkAPI.rejectWithValue(errorMessage);
      }

      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
